<div class="tw-flex tw-flex-col tw-gap-6 tw-w-full" aria-busy="true" aria-label="Loading invitation tracker">
  <div class="tw-flex tw-items-center tw-gap-2 tw-w-full tw-overflow-hidden">
    @for (width of tabPlaceholders; track width) {
      <div
        class="tw-h-[41px] tw-shrink-0 tw-rounded-md tw-bg-gray-200 tw-animate-pulse"
        [style.width.px]="width"
      ></div>
    }
  </div>

  <app-invitation-tracker-statistics class="tw-w-full" [isLoading]="true" />

  <div class="tw-flex tw-items-center tw-gap-2 lg:tw-gap-3 tw-w-full tw-h-10 lg:tw-h-[42px]">
    <div class="tw-flex tw-flex-1 tw-items-center tw-gap-2 lg:tw-gap-3 tw-min-w-0">
      <div class="tw-h-10 lg:tw-h-[42px] tw-flex-1 lg:tw-flex-none lg:tw-w-60 xl:tw-w-80 tw-min-w-0 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
      <div class="tw-h-[41px] tw-w-[41px] tw-shrink-0 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse lg:tw-hidden"></div>
      @for (filter of filterPlaceholders; track filter) {
        <div class="tw-hidden lg:tw-block tw-h-[42px] tw-w-[119px] xl:tw-w-[122px] tw-shrink-0 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
      }
    </div>

    <div class="tw-flex tw-items-center tw-gap-2 lg:tw-gap-3 tw-shrink-0">
      <div class="tw-h-10 tw-w-10 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse lg:tw-hidden"></div>
      <div class="tw-h-10 tw-w-10 lg:tw-h-[42px] lg:tw-w-[90px] xl:tw-w-[159px] tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
      <div class="tw-hidden lg:tw-block tw-h-[42px] lg:tw-w-[84px] xl:tw-w-[138px] tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
    </div>
  </div>

  <div class="tw-flex tw-flex-col tw-w-full tw-rounded-lg tw-border tw-border-gray-200 tw-overflow-hidden">
    <div class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3 tw-border-b tw-border-gray-200 tw-bg-gray-50">
      <div class="tw-h-4 tw-w-4 tw-rounded tw-bg-gray-200 tw-animate-pulse tw-shrink-0"></div>
      <div class="tw-h-4 tw-flex-1 tw-max-w-[120px] tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
      <div class="tw-h-4 tw-flex-1 tw-max-w-[156px] tw-rounded tw-bg-gray-200 tw-animate-pulse tw-hidden sm:tw-block"></div>
      <div class="tw-h-4 tw-flex-1 tw-max-w-[200px] tw-rounded tw-bg-gray-200 tw-animate-pulse tw-hidden md:tw-block"></div>
      <div class="tw-h-4 tw-flex-1 tw-max-w-[96px] tw-rounded tw-bg-gray-200 tw-animate-pulse tw-hidden lg:tw-block"></div>
    </div>

    @for (row of tableRows; track row) {
      <div class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-4 tw-border-b tw-border-gray-200 last:tw-border-b-0">
        <div class="tw-h-4 tw-w-4 tw-rounded tw-bg-gray-200 tw-animate-pulse tw-shrink-0"></div>
        <div class="tw-h-4 tw-flex-1 tw-max-w-[140px] tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
        <div class="tw-h-4 tw-flex-1 tw-max-w-[180px] tw-rounded tw-bg-gray-200 tw-animate-pulse tw-hidden sm:tw-block"></div>
        <div class="tw-h-4 tw-flex-1 tw-max-w-[220px] tw-rounded tw-bg-gray-200 tw-animate-pulse tw-hidden md:tw-block"></div>
        <div class="tw-h-4 tw-flex-1 tw-max-w-[80px] tw-rounded tw-bg-gray-200 tw-animate-pulse tw-hidden lg:tw-block"></div>
      </div>
    }
  </div>
</div>
